import request from '@/utils/request'

export function fetchList(params) {
  return request({
    url: '/problem/page',
    method: 'get',
    params
  })
}

export function addObj(data) {
  return request({
    url: '/problem/add',
    method: 'post',
    data
  })
}
export function putObj(data) {
  return request({
    url: '/problem/edit',
    method: 'post',
    data
  })
}
export function delObj(data) {
  return request({
    url: '/problem/delete',
    method: 'post',
    data
  })
}
export function getObj(id) {
  return request({
    url: '/problem/detail',
    method: 'get',
    params: { id }
  })
}
export function putStatus(data) {
  return request({
    url: '/problem/status',
    method: 'post',
    data
  })
}
